module.exports = __webpack_public_path__ + "static/media/sports_3.b4fd442a.jpg";